<template>
  <div class="verify">
    <div class="close"><span @click="refreshUserInfo">&times;</span></div>
    <div class="text-center">
      <img :src="require('@/assets/verify-bg.png')" alt="" class="verify-img">
      <p class="mt-15">{{ msg }}</p>
    </div>
    <div class="text-center btn-wrapper">
      <van-button v-if="userInfo.group_id === 1 && userInfo.real_type != 'nonage' && ![1, 2, 3].includes(status)" block color="#fc3159" size="small" :url="realUrl">成年音乐人实名认证</van-button>
      <van-button v-if="userInfo.group_id === 2 && ![1, 2, 3].includes(status)" block size="small" :url="realUrl" color="#fc3159" class="mt-15">企业账号实名认证</van-button>
      <van-button v-if="status != 2" block size="small" color="#fc3159" class="mt-15" @click="checkUserInfo">我已完成实名认证</van-button>
      <van-button v-if="userInfo.real_type === 'nonage' && userInfo.is_agent != 1 && ![1, 2].includes(status)" block size="small" class="mt-15" to="/realidcation">变更监护人信息</van-button>
      <!-- 实名认证失败出现的重新认证 -->
      <van-button v-if="status === 2" block size="small" class="mt-15" @click="resetRealidcationUrl">重新认证</van-button>
      <van-button v-if="status != 1" block size="small" class="mt-15" @click="cancellation">注销账号(请谨慎操作)</van-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { cancellation } from '@/api/register.js'
export default {
  name: 'VerifyPage',
  data() {
    return {
      realUrl: '',
      status: 0,
      msg: '您的账号未完成实名认证，请点击下方实名认证按钮进行认证'
    }
  },
  computed: {
    ...mapState(['userInfo', 'isPlus'])
  },
  async created() {
    this.$nextTick(async () => {
      try {
        await this.$store.dispatch('getUserInfo')
        if (this.userInfo.is_verify === 1) {
          // 关闭弹窗
          this.$store.commit('TOGGLE_VERIFY', false)
        } else {
          // 打开弹窗
          this.$store.commit('TOGGLE_VERIFY', true)
        }
        this.$store.commit('TOGGLE_LOADING', true)

        if (this.userInfo.real_type === 'nonage') { // 未成年人
         this.msg = '请等待监护人完成实名认证操作'
        } else {
          await this.getRealidcation()
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    })
  },
  methods: {
    async checkUserInfo() { // 确认已认证
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        await this.getRealidcation()
        await this.$store.dispatch('getUserInfo')
        if (this.$store.state.userInfo.is_verify === 1) {
          // 关闭弹窗
          this.$store.commit('TOGGLE_VERIFY', false)
        } else {
          // 打开弹窗
          this.$store.commit('TOGGLE_VERIFY', true)
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async cancellation() {
      try {
        await this.$dialog.confirm({
          title: '提示',
          message: '注意：点击此操作将清空账号内的所有信息，请谨慎!!!'
        })
        // 注销账号
        const res = await cancellation({})
        if (res.code === 1) {
          // 关闭弹窗
          this.$store.commit('TOGGLE_VERIFY', false)
          // 注销成功
          this.$router.push('/login')
          return
        }
      } catch(err) {
        // 取消注销账号
        console.log(err)
      }
    },
    async resetRealidcationUrl() {
      this.$store.commit('TOGGLE_LOADING', true)
      try {
        const params = { jump: this.isPlus ? 4 : (this.userInfo.is_agent ? 3 : 2) }
        const res = await this.$store.dispatch('getRealidcation', params)
        if (res.code === 1) {
          res.data.url && (location.href = res.data.url) || (this.$toast(res.msg))
        }
      } finally {
        this.$store.commit('TOGGLE_LOADING', false)
      }
    },
    async getRealidcation() {
      /* 0: 不跳
         1：项目首页
         2：cp下载页
         3：代理下载页
         4: 返回app内首页 */
      const params = { jump: this.isPlus ? 4 : (this.userInfo.is_agent ? 3 : 2) }
      const res = await this.$store.dispatch('getRealidcation', params)
      if (res.code === 1) {
        if (res.data) {
          this.realUrl = res.data.url
          this.status = res.data.status
        }

        await this.$store.dispatch('getUserInfo')
        if (res.data.status != 0) {
          this.msg = res.msg
        }
      }
    },
    async refreshUserInfo() {
      await this.$store.dispatch('getUserInfo')
      if (this.$store.state.userInfo.is_verify !== 1) {
        // 清除token，跳转到登录页面
        await this.$store.dispatch('logout')
        this.$router.push('/login')
      }
      // 关闭弹窗
      this.$store.commit('TOGGLE_VERIFY', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.verify{
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  z-index: 999;
  padding: 15px;
  background-color: rgba(0, 0, 0, .5);
  color: #fff;
  .verify-img{
    width: 126px;
  }
  .close{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    font-size: 30px;
    line-height: 30px;
    text-align: right;
  }
  .btn-wrapper{
    width: 100%;
    padding-bottom: 20px;
  }
}
</style>
